import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
// common footer component for all pages
export class FooterComponent {

  constructor() {
    // This is intentional
  }
}
